module.exports = __webpack_public_path__ + "static/media/creator-awards-logo.dd8efc5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/creator-awards-logo.png
// module id = 122
// module chunks = 0